import { render, staticRenderFns } from "./SaleLeads.vue?vue&type=template&id=3fecceb8"
import script from "./SaleLeads.vue?vue&type=script&lang=js"
export * from "./SaleLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports